module.exports = __webpack_public_path__ + "cfa61fc4ddbbb91c18c0e3ea0196e209.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/trumpet/6_F2.mp3
// module id = 122
// module chunks = 0